import React from 'react';
import { FrameProps } from 'types/common/PropsTypes';

const FrameRow = ({ addClassName, children }: FrameProps) => {
  return <div className={`row ${addClassName ?? ''}`}>{children}</div>;
};

export default React.memo(FrameRow);
